import { render, staticRenderFns } from "./cubeQuery.vue?vue&type=template&id=5c84f79a&scoped=true&"
import script from "./cubeQuery.vue?vue&type=script&lang=js&"
export * from "./cubeQuery.vue?vue&type=script&lang=js&"
import style0 from "./cubeQuery.vue?vue&type=style&index=0&lang=less&"
import style1 from "./cubeQuery.vue?vue&type=style&index=1&id=5c84f79a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84f79a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c84f79a')) {
      api.createRecord('5c84f79a', component.options)
    } else {
      api.reload('5c84f79a', component.options)
    }
    module.hot.accept("./cubeQuery.vue?vue&type=template&id=5c84f79a&scoped=true&", function () {
      api.rerender('5c84f79a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cubeQuery.vue"
export default component.exports